const sanitizeColId = (colId) => colId.replace(/\./g, "_");
export const columnTransformVar = (colId) => `--col-${sanitizeColId(colId)}-transform`;
export const columnWidthVar = (colId) => `--col-${sanitizeColId(colId)}-width`;
export const columnOpacityVar = (colId) => `--col-${sanitizeColId(colId)}-opacity`;
export const columnTransition = () => `--col-transition`;
export const actionsHeaderWidthVar = `--actions-header-width`;
export const displayScrollRightIndicatorVar = `--display-scroll-right-indicator`;
export const scrollContainerWidthVar = `--scroll-container-width`;
export const tableMinWidthVar = `--table-min-width`;
